export function hasMenuRoute(menu, route) {
  if (!Array.isArray(menu)) {
    return false;
  }

  return menu.some(item => {
    if (!item) {
      return false;
    }

    if (item.route === route) {
      return true;
    }

    return hasMenuRoute(item.subitems, route);
  });
}

export default function hasRadioRoute(menu) {
  return hasMenuRoute(menu, "/radio");
}
